import { createContext, useCallback, useState } from "react";
import { toast } from "react-toastify";
import axiosInstance from "../services/axiosConfig";

export const LogisticsContext = createContext();

// eslint-disable-next-line react/prop-types
export const LogisticsProvider = ({ children }) => {
  const [logisticsData, setLogisticsData] = useState({ rows: [], columns: [] });

  const formatDate = (value) => {
    if (!value) return "";
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return value;
    return date.toLocaleDateString("tr-TR");
  };

  const handleUnauthorized = useCallback(() => {
    toast.warn("Bu içeriği görüntüleme yetkiniz yok.", { position: "top-right" });
  }, []);

  const fetchLogisticsData = useCallback(
    async (role) => {
      const endpoint =
        role === "ROLE_ACCOUNTANT"
          ? "accountant/invoice/pending-logistics"
          : "accountant/invoice/pending-logistics";

      try {
        const response = await axiosInstance.get(endpoint);
        const rows = (response.data || []).map((item) => ({
          id: item.id,
          agreedArrivalTime: formatDate(item.agreedArrivalTime),
          status: item.status,
          createdByName: item.createdByName || item.createdById,
          logisticsInvoiceStatus: item.logisticsInvoice?.status,
          logisticsInvoiceTotal: item.logisticsInvoice?.totalAmount,
          fullData: item,
        }));

        const columns = [
          { field: "id", headerName: "ID", width: 90 },
          { field: "agreedArrivalTime", headerName: "Geliş Tarihi", width: 150 },
          { field: "status", headerName: "Durum", width: 150 },
          { field: "createdByName", headerName: "Oluşturan", width: 150 },
        ];

        setLogisticsData({ rows, columns });
        return { rows, columns };
      } catch (error) {
        if (error.response?.status === 403) handleUnauthorized();
        console.error("Failed to fetch logistics data:", error);
        return { rows: [], columns: [] };
      }
    },
    [handleUnauthorized]
  );

  return (
    <LogisticsContext.Provider value={{ ...logisticsData, fetchLogisticsData }}>
      {children}
    </LogisticsContext.Provider>
  );
};
